package com.nonopn.skydome.common.app.navigation.scaffold

import androidx.compose.foundation.layout.Column
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import com.nonopn.skydome.common.app.home.LocalApp
import com.nonopn.skywatcher.design.appbar.FloatingActionButton
import com.nonopn.skywatcher.design.appbar.FloatingActionButtonState
import com.nonopn.skywatcher.design.appbar.MultiFloatingActionButton
import com.nonopn.skywatcher.design.widgets.BottomSpacer

@Composable
fun FloatingActionButtonWrapper() {
    val state by LocalApp.current.states.collectAsState()

    Column {
        state.floatingActionButtonState?.let {
            when (it) {
                is FloatingActionButtonState.Button -> FloatingActionButton(
                    floatingActionButtonState = it,
                )

                is FloatingActionButtonState.Menu -> MultiFloatingActionButton(
                    floatingActionButtonState = it
                )
            }

            BottomSpacer()
        }
    }
}
